import axios from "@/plugins/axios";
import store from "@/store";
import router from "@/router";

async function apiIsLoggedIn() {
  const response = await axios.post("?Mode=General&Function=IsLoggedIn");
  if (response.data.Result) {
    store.commit("setIsLoggedIn", true);
  } else {
    store.commit("setIsLoggedIn", true);
  }
  return response;
}

async function apiLogout() {
  const response = await axios.post("?Mode=General&Function=Logout");
  console.log(response);
  if (response.data.Status === "Error") {
    store.commit("setErrors", response.data.Errors);
  } else {
    store.commit("setUser", {});
    store.commit("setRoodieChecks", {});
    store.commit("setFiles", []);
    store.commit("setConversations", []);
    store.commit("setDoctors", {
      doctors: [],
      appointments: [],
      proposed: [],
    });
    store.commit("setResetHomeViewForce", true);
    store.commit("setCloseMenu", true);
    router.push("/login");
  }
}

export { apiIsLoggedIn, apiLogout };
